import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PricingsState, Pricing } from './pricingTypes';
import { pricingAPI } from './pricingAPI';

const initialState: PricingsState = {
  currentPricing: null,
  Pricings: [],
  agents: [],
  tasks: [],
  codeGenerations: [],
  loading: false,
  error: null,
};

const pricingsSlice = createSlice({
  name: 'pricings',
  initialState,
  reducers: {
    setCurrentPricing: (state, action: PayloadAction<Pricing | null>) => {
      state.currentPricing = action.payload;
    },
    clearPricingsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Pricings
    builder.addMatcher(
      pricingAPI.endpoints.getPricings.matchPending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    );
    builder.addMatcher(
      pricingAPI.endpoints.getPricings.matchFulfilled,
      (state, action) => {
        state.loading = false;
        state.Pricings = action.payload;
      }
    );
    builder.addMatcher(
      pricingAPI.endpoints.getPricings.matchRejected,
      (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to fetch pricings';
      }
    );
    
    
  },
});

export const { setCurrentPricing, clearPricingsError } = pricingsSlice.actions;
export default pricingsSlice.reducer;